<template>
  <div class="layout_basic">
    <div class="layout_panel main">
      <router-view></router-view>
    </div>
    <Dialog v-for="(item, index) in $store.state.dialogStack" :key="index" :config="item"></Dialog>
  </div>
  
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>

</style>
